class JournalController extends AbstractController
	@register()
	@inject '$scope',
		'$window'
		'shops'
		'registers'
		'JournalServiceRepository'

	initialize: ->
		@filter =
			shop_id: null
			register_id: null
			date_from: null
			date_to: null
		@downloadEnabled = false
		@filteredRegister = @registers

	download: ->
		return if @filter.shop_id == null && @filter.register_id == null

		@JournalServiceRepository.download(@getQuery())

	onShopChange: ->
		@filter.register_id = null

		@JournalServiceRepository
			.listRegisters @filter.shop_id
			.then (registers) =>
				@registers = registers

				if @registers.length == 1
					@filter.register_id = @registers[0].register_id

				@onChange()
			.catch (response) =>
				@handleErrors response, 'electric.journal'

	onChange: ->
		@downloadEnabled = false
		@numberOfEntries = null

		return if @filter.shop_id == null && @filter.register_id == null

		@JournalServiceRepository
			.count(@getQuery())
			.then (response) =>
				@numberOfEntries = response.data.count
				@downloadEnabled = @numberOfEntries > 0

	getQuery: ->
		query = @JournalServiceRepository.createQuery()

		query.criteria 'shop_id', '=', @filter.shop_id if @filter.shop_id != null
		query.criteria 'register_id', '=', @filter.register_id if @filter.register_id != null
		query.criteria 'timestamp', '>', @filter.date_from if @filter.date_from != null
		query.criteria 'timestamp', '<', @filter.date_to if @filter.date_to != null

		return query
